export enum Articulation {
  HammerOn = 'h',
  PullOff = 'p',
  Slide = 's',
  Bend = 'b',
  BendRelease = 'b',
  /** A bend release, `5b7r5`. The parser has always emitted 'r'; it was simply not a member. */
  Release = 'r',
  Tap = 't',
}
